import { render, staticRenderFns } from "./OrtopediHastaGuncelleme.vue?vue&type=template&id=2df3a2d6&scoped=true&"
import script from "./OrtopediHastaGuncelleme.vue?vue&type=script&lang=js&"
export * from "./OrtopediHastaGuncelleme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df3a2d6",
  null
  
)

export default component.exports